const websiteConfigCollection = require('od-modules/collections/website.collection').getInstance();
const utils = require('./utils');

const EVENTS = {
    GO_TO_PAX: 'shoppingCartCreated',
    GO_TO_FARE_RULES: 'showFareRules',
};

const getEvent = (items = []) => utils.hasFareRules(items) ? EVENTS.GO_TO_FARE_RULES : EVENTS.GO_TO_PAX;

class Manager {
    constructor() {
        this.promise = null;
    }

    load() {
        this.promise = new Promise((resolve) => {
            this.resolve = resolve;
        });

        websiteConfigCollection.getLoadedPromise().then(() => {
            return utils.isInScope() ? this.loadFareRules() : this.resolve(EVENTS.GO_TO_PAX);
        });

        return this.promise;
    }

    getPromise() {
        if (this.promise) {
            return this.promise;
        }

        return this.load();
    }

    loadFareRules() {
        utils.getFareRules().then((items) => {
            this.resolve(getEvent(items));
        }).catch(() => this.resolve(EVENTS.GO_TO_PAX));
    }

    hasFareRules() {
        return utils.getFareRules()
            .then((items) => utils.hasFareRules(items))
            .catch(() => false);
    }

    then(callback = () => {}) {
        this.getPromise().then(callback);
    }
}

module.exports = {
    fareRuleEvents: EVENTS,
    fareRulesManager: new Manager(),
};
